export function barcodeConflict(details, index) {
  const row = details[index];
  if (!row?.newBarcode) return false;
  return details.some((other, i) => i !== index &&
    other.newBarcode === row.newBarcode &&
    Number(other.companyUnitId || 0) === Number(row.companyUnitId || 0));
}

export function createPriceRows(option, selectedIds, existing) {
  if (!option.newBarcode.trim()) throw new Error("Shënoni barkodin.");
  if (!option.articleUnitID) throw new Error("Zgjidhni njësinë e artikullit.");
  if (option.articleUnitQty == null || String(option.articleUnitQty).trim() === "")
    throw new Error(Number(option.typeOfSales) === 2
      ? "Plotësoni sasinë në paketim për çmimin me shumicë."
      : "Plotësoni sasinë në paketim.");
  if (!Number.isFinite(Number(option.articleUnitQty)) || Number(option.articleUnitQty) <= 0)
    throw new Error("Sasia në paketim duhet të jetë më e madhe se zero.");
  if (option.newSalesPrice === "" || !Number.isFinite(Number(option.newSalesPrice)) || Number(option.newSalesPrice) < 0)
    throw new Error("Shënoni një çmim të vlefshëm.");
  if (!selectedIds.length) throw new Error("Zgjidhni të paktën një njësi organizative.");
  const rows = [...new Set(selectedIds.map(Number))].map(companyUnitId => ({
    ...option, newBarcode: option.newBarcode.trim(), companyUnitId, isActive: true,
    articleUnitID: Number(option.articleUnitID), typeOfSales: Number(option.typeOfSales),
    articleUnitQty: Number(option.articleUnitQty), newSalesPrice: Number(option.newSalesPrice),
  }));
  const all = [...existing, ...rows];
  if (rows.some((_, i) => barcodeConflict(all, existing.length + i)))
    throw new Error("Ky barkod ka një çmim në njësinë e zgjedhur. Ndryshoni rreshtin ekzistues ose përdorni barkod tjetër për paketimin.");
  return rows;
}
